import React							from 'react';
import {flexRender}						from '@tanstack/react-table';

import Icon								from '../Icon';
import Load								from '../Load';

import {TableProps}						from './interface';

import ft_cssVar						from '../../functions/getCssVar';

import img_chevron						from '../../images/icon/arrow/chevron-down.svg';

import './Table.css';


function Table(props: TableProps): JSX.Element {
	return (
		<div style={{overflow: 'auto', overflowY: 'scroll'}}>
			<table className={'importTable'}>
				<thead>
					{props.data.getHeaderGroups().map(headerGroup => (
						<tr key={headerGroup.id}>
							{headerGroup.headers.map((header) => {
								const hSort = header.column.getIsSorted() as string;

								return (
									<th
										key={header.id}
										colSpan={header.colSpan}
										style={header.column.getSize() !== 150 ? {
											width: header.column.getSize()
										} : {}}
									>
										{!header.isPlaceholder &&
											<div
												onClick={header.column.getToggleSortingHandler()}
												style={{
													display:   'flex',
													textAlign: 'left',
													cursor:    header.column.getCanSort() ? 'pointer' : ''
												}}
											>
												{flexRender(header.column.columnDef.header, header.getContext())}
												{hSort &&
													<Icon
														iconSize={12}
														icon={img_chevron}
														iconColor={ft_cssVar('gray-600')}
														style={{
															marginLeft: 6,
															transform:  `rotate(${hSort === 'asc' ? '' : '18'}0deg)`
														}}
													/>
												}
											</div>
										}
									</th>
								);
							})}
						</tr>
					))}
				</thead>
				{props.load ?
					<Load key={'load'} center />
					:
					<tbody>
						{props.data.getRowModel().rows.map(row => (
							<tr
								key={row.id}
								data-hover={!!props.onClickRow}
								onClick={() => props.onClickRow && props.onClickRow(row)}
							>
								{row.getVisibleCells().map(cell => (
									// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
									<td
										key={cell.id}
										onClick={e => cell.id?.endsWith('select') && e.stopPropagation()}
									>
										{flexRender(cell.column.columnDef.cell, cell.getContext())}
									</td>
								))}
							</tr>
						))}
					</tbody>
				}
			</table>
		</div>
	);
}

export default Table;